import React, { Component } from 'react';
import Card from '../../../CardNew';
import { LIVECHANNEL } from '../../constants';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import './styles.scss';

class RibbonLiveChannel extends Component {
    constructor(props) {
        super(props);
        this.carruselTitle = props.carruselTitle;
        this.items = props.items;
        this.visibleItems = props.visibleItems;
        this.badgesUserType = props.badgesUserType;
        this.ignoreSeenLast = props.ignoreSeenLast;
        this.focusSettings = props.focusSettings;
        this.ribbonId = props.ribbonId;
        this.focusHandler = props.focusHandler;
        this.setMetricsEvent = props.setMetricsEvent;
        this.hideInnerTitle = props.hideInnerTitle;
        this.keyDownHandler = props.keyDownHandler;
        this.className = props.className;
        this.title = props.title;
        this.focusHandler = props.focusHandler;
        this.unFocusHandler = props.unFocusHandler;
        this.onClickHandler = props.onClickHandler ? props.onClickHandler : null;
        this.typeRender = props.typeRender ? props.typeRender : null;
        this.ribbonIndex = props.ribbonIndex;
        this.api = props.api;
        this.dataUpdateMetrics = props.dataUpdateMetrics;
        this.ribbonName = props.ribbonName;
        this.idsRibbonsUpAndDown = props.idsRibbonsUpAndDown;

    }

    clickHandler(data) {
        this.onClickHandler && this.onClickHandler(data);
    }

    render() {
        return (
            <div className="ribbon-items ribbon-livechannel">
                {this.visibleItems.map((node, index) => {
                    const node_item = node.item;
                    const badges = GeneralRibbonUtils.getBadgesHTML(this.badgesUserType, node_item);
                    const key = Math.random() * 10;
                    const dataMetricsRibbon = {
                        node_item,
                        node_location: location.pathname,
                        ribbon_title: this.props.carruselTitle || this.ribbonId,
                    };
                    return (
                        <Card
                            cover={node_item.cover}
                            unFocusHandler={this.unFocusHandler}
                            focusHandler={this.focusHandler}
                            id={index + 1}
                            ribbonId={this.ribbonId}
                            key={key}
                            ribbonIndex={this.ribbonIndex}
                            ignoreSeenLast={this.ignoreSeenLast}
                            data={node_item}
                            group_id={node_item.group_id}
                            typeRender={this.typeRender}
                            onClick={(e) => {
                                this.dataUpdateMetrics(dataMetricsRibbon);
                                e.preventDefault();
                                e.stopPropagation();
                                this.clickHandler(node_item);
                            }}
                            hideTitles={this.props.hideTitles}
                            isRecentActivity={this.props.isRecentActivity}
                            label={node_item.label}
                            type={LIVECHANNEL}
                            title={node_item.title}
                            badges={badges}
                            dataMetric={{
                                carruselTitle: this.carruselTitle,
                                cardPosition: GeneralRibbonUtils.getPosition(
                                    this.items,
                                    node_item.title
                                ),
                            }}
                            focusable={true}
                            focusRight={`#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusLeft={`#${this.ribbonId} ${this.focusSettings.selector}`}
                            setMetricsEvent={this.setMetricsEvent}
                            sibling={node_item.sibling}
                            hideInnerTitle={this.hideInnerTitle}
                            keyDownHandler={this.keyDownHandler}
                            is_music={false}
                            api={this.api}
                            ribbonName={this.ribbonName}
                            ribbonLength= {this.visibleItems.length}
                            idsRibbonsUpAndDown={this.idsRibbonsUpAndDown}
                        />
                    );
                })}
            </div>
        );
    }
}

export default RibbonLiveChannel;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonLiveChannel/index.jsx